"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Message_1 = __importDefault(require("../i18n/Message"));
var Price = /** @class */ (function (_super) {
    __extends(Price, _super);
    function Price() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
    Price.prototype.numberWithCommas = function (x) {
        var parts = x.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    };
    Price.prototype.render = function () {
        var displayPrice = 'ASK';
        if (this.props.openPrice) {
            displayPrice = react_1.default.createElement(Message_1.default, { messageId: "price.openPrice" });
        }
        else {
            if (this.props.currency && this.props.price) {
                var currency = this.props.currency;
                var price = parseFloat(this.props.price);
                var rounding = 2;
                var symbol = '$';
                if (currency == 'JPY') {
                    symbol = '¥';
                    rounding = 0;
                }
                var roundingMultiplier = Math.pow(10.0, rounding);
                var priceRounded = Math.round(price * roundingMultiplier) / roundingMultiplier;
                displayPrice = "" + symbol + this.numberWithCommas(priceRounded);
                if (isNaN(priceRounded)) {
                    displayPrice = '\u00a0';
                }
            }
        }
        return react_1.default.createElement("span", null, displayPrice);
    };
    Price.propTypes = {
        currency: prop_types_1.default.string,
        price: prop_types_1.default.any,
        openPrice: prop_types_1.default.bool,
    };
    return Price;
}(react_1.default.Component));
exports.default = Price;
//# sourceMappingURL=Price.js.map